
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.75 1.254a.88.88 0 00-.281-.633c-.176-.14-.387-.246-.598-.246H.88a.872.872 0 00-.633.246.847.847 0 00-.246.633v13.992c0 .246.07.457.246.633.14.176.352.246.633.246h7.523v-6.117h-2.04V7.652h2.04V5.895c0-.985.28-1.758.843-2.32.563-.528 1.3-.81 2.215-.81.703 0 1.336.036 1.828.07V4.98h-1.266c-.457 0-.773.106-.949.317-.14.176-.21.457-.21.844v1.511h2.355l-.317 2.356h-2.039v6.117h4.008c.246 0 .457-.07.633-.246a1.01 1.01 0 00.246-.633V1.254z"}})])
          )
        }
      }
    